import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import './DropdownMenu.scoped.sass'
import store from '@/core/store'
import commonsService from '@/services/commons.service'

export function DropdownMenu () {
  const [isOpened, setIsOpened] = useState(false)
  const [dropdownProps, setDropdownProps] = useState({
    type: '',
    position: '',
    coordinates: {},
    menuOptions: []
  })
  
  useEffect(() => {
    store.on('DROPDOWN:OPEN', ({ menuOptions, coordinates, position }) => {
      setDropdownProps({
        menuOptions,
        coordinates: commonsService.isMobile() ? {} : coordinates,
        position,
      })
      setIsOpened(true)
    })
    store.on('DROPDOWN:CLOSE', () => {
      setIsOpened(false)
      setDropdownProps({
        type: '',
        position: '',
        coordinates: {},
        menuOptions: [],
      })
    })
  }, [])

  return isOpened && <>
    {commonsService.isMobile() && <div className='overlay-back' onScroll={(e) => {
      e.preventDefault()
      e.stopPropagation()
    }}></div>}
    <div className={`dropdown-container ${dropdownProps.type}`} style={dropdownProps.coordinates}>
      <ul onClick={(e) => e.stopPropagation()} className={dropdownProps.position}>
        {dropdownProps.menuOptions.map((option, index) => {
          if (option.separator) return <div key={index} className='separator' />
          if (option.info) return <li key={index} className='dropdown-info'>{option.info}</li>
          return <li key={index} onClick={option.action} className={classNames('dropdown-button', { red: option.color === 'red' })}>
            <div className="dropdown-icon">
              {option.icon}
            </div>
            <div className="dropdown-title">
              {option.title}
            </div>
          </li>
        })}
      </ul>
    </div>
  </>
}
